var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8135 6.17773C10.8135 6.7666 11.2881 7.23242 11.8857 7.23242C12.4834 7.23242 12.9492 6.7666 12.9404 6.17773C12.9404 5.57129 12.4834 5.09668 11.8857 5.09668C11.2881 5.09668 10.8135 5.57129 10.8135 6.17773ZM8.60742 17.8672C8.60742 18.2012 8.84473 18.4209 9.19629 18.4209H14.7949C15.1465 18.4209 15.3838 18.2012 15.3838 17.8672C15.3838 17.542 15.1465 17.3223 14.7949 17.3223H12.8262V10.168C12.8262 9.80762 12.5889 9.57031 12.2461 9.57031H9.52148C9.16113 9.57031 8.92383 9.78125 8.92383 10.1152C8.92383 10.4404 9.16113 10.6689 9.52148 10.6689H11.5957V17.3223H9.19629C8.84473 17.3223 8.60742 17.542 8.60742 17.8672Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.5541886f005d8df89b82ef13c16c121f.svg";
export { ForwardRef as ReactComponent };